import { useEffect, useState } from 'preact/hooks';
import { useField, FieldValidator, Field } from 'formik';
import DatePicker from 'react-datepicker';
import { addMonths, isValid, parseJSON } from 'date-fns';
import { FieldError } from './FieldError';
import { CalendarIcon } from '../ecardsPreact.icons/CalendarIcon';
import { parseDeliveryDate } from './App';

export const DatePickerField = ({ name, label, placeholder, wrapperClass, onChange, characterLimit, ...props }) => {
    const [field, meta, helpers] = useField(name);
    const fieldClassName = `form-field form-field--date${meta.error && meta.touched ? ' form-field--error' : ''}${wrapperClass ? ` ${wrapperClass}` : ''}`;

    const minDate = new Date();
    const maxDate = addMonths(minDate, 12);

    const [selectedDate, setSelectedDate] = useState(isValid(field.value) ? parseJSON(field.value) : undefined);

    function handleChange(date) {
        setSelectedDate(date);
    }

    function handleBlur() {
        helpers.setTouched(true);
    }

    useEffect(() => {
        helpers.setValue(parseDeliveryDate(selectedDate));
    }, [selectedDate]);

    return (
        <div class={fieldClassName}>
            <div class="form-field__label-wrapper">
                <label class="form-field__label label" htmlFor={field.name}>
                    {label}

                    {props.required && <span class="label__required">&nbsp;*</span>}
                </label>
            </div>

            <div class="form-field__icon-wrapper">
                <CalendarIcon width="24" height="24" class="form-field__icon text-blue" />
                <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={selectedDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    id={field.name}
                    name={field.name}
                    className="form-field__input form-field__input--date input"
                    placeholderText={placeholder}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onCalendarClose={handleBlur}
                />
            </div>
            <FieldError {...meta} />
        </div>
    );
};
